import LanguageControllerResponsive from './LanguageControllerResponsive'

export default LanguageControllerResponsive



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageControllerResponsive/index.js